import AppTextField from '@/components/AppTextField';
import NationChooser from '@/components/NationChooser';
import SendCodeButton from '@/components/SendCodeButton';
import AppLoadingButton from '@/components/mui/LoadingButton';
import API from '@/constant/API';
import RouteConstant from '@/constant/RouteConstant';
import { VerifyAction } from '@/constant/VerifyConstant';
import { clearTaskRule, getTaskId, getUserInfo, onForgotPwState, onUserInfo, setTaskId, setTaskRuleParams, setToken,setTmpToken } from '@/redux/slices/user';
import { dispatch } from '@/redux/store';
import { signInGoogle } from '@/utils/auth';
import axiosInstance from '@/utils/axios';
import { getDeviceId,isJSONStr } from '@/utils/utils';
import {
  Divider,
  InputAdornment,
  Box,
  Stack,
  IconButton,
  Link,
  useTheme,
  CircularProgress,
  circularProgressClasses
} from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {createSearchParams, useNavigate } from 'react-router-dom';
import classes from "./css/index.module.less";
import AppModal from '@/components/AppModal';
import Security2FA from '@/pages/security/Security2FA';
import useToggle from '@/hook/useToggle';
import RpIcon from "@/components/RpIcon";
import NationSelect from "@/components/NationSelect";
import PasswordInput from "@/components/PasswordInput";

enum LOGIN_STEP {
  LOGIN_CHECK_EXIST,
  LOGIN_PW_INPUT,
  LOGIN_PW_SET,
}

export default function InviteLoginForm({ accessToken, onAccessTokenUsed, setIsLogin, interceptAction }) {
  const {t} = useTranslation();
  const theme = useTheme();
  useEffect(() => {
    clearTaskRule();
    if (accessToken) {
      autoSubmitOn3rdAuth(accessToken);
      onAccessTokenUsed?.();
    }
  }, [accessToken]);

  const navigate = useNavigate();

  const {
    toggle: show2FA,
    onToggle: onToggleShow2FA,
  } = useToggle(false);

  const [loginStep, setLoginStep] = useState(LOGIN_STEP.LOGIN_CHECK_EXIST);

  const sendCodeBtnRef = useRef(null);

  const [username, setUsername] = useState('');
  const [loginUserInfo, setLoginUserInfo] = useState(null);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [checkLoginToken, setCheckLoginToken] = useState(null);
  const [nationCode, setNationCode] = useState(null);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const [asMobile, setAsMobile] = useState(false);

  const [nationRecord, setNationRecord] = useState(null);

  const [usernameError, setUsernameError] = useState(null);
  const [codeError, setCodeError] = useState(null);

  const [googleLogining, setGoogleLogining] = useState(false);

  const [visiblePassword, setVisiblePassword] = useState(null);
  const handleTogglePasswordVisibility = (field) => {
    setVisiblePassword((prev) => (prev === field ? null : field));
  };

  const autoSubmitOn3rdAuth = async (token) => {
    setUsernameError(false);
    setCodeError(false);

    try {
      setLoading(true);
      const params = {
        // 'deviceInfo': appController.deviceId,
        // 'deviceName': appController.deviceModel,
        'providerId': 'google.com',
        'thirdToken': token,
        username: token
        // accessToken: accessToken3rd,
      };
      
      const res = await axiosInstance.post(API.LOGIN_3RD_AUTH_V2, params);
      onLoginCallback(res);

      _onSubmitHandlerSuccess();
    } catch(error) {
    } finally {
      setLoading(false);
    }
  };

  const _onSubmitHandlerSuccess = () => {
    navigate(RouteConstant.MAIN, {
      replace: true
    });
  }

  const _onClose2FAModal = () => {
    setTaskId(null);
    setTaskRuleParams(null);
    onToggleShow2FA();
  }

  const handleSubmit = useCallback(async (evt) => {
    evt.preventDefault();

    if (loginStep === LOGIN_STEP.LOGIN_CHECK_EXIST) {
      _checkLoginExist();
    } else if (loginStep === LOGIN_STEP.LOGIN_PW_INPUT) {
      _loginPw();
    } else if (loginStep === LOGIN_STEP.LOGIN_PW_SET) {
      _loginPwSet();
    }
  }, [loginStep, asMobile, nationCode, username, password, code]);

  // 检查用户是否存在
  const _checkLoginExist = async () => {
    setUsernameError(!username.trim());
    // if (!REGEXP.EMAIL.test(username.trim() ?? '')) {
    //   return;
    // }

    if (asMobile && nationCode == null) {
      return;
    }
    
    try {
      setLoading(true);
      const params = {
        username,
      };
      if (asMobile) {
        params.nationCode = nationCode;
      }
      
      const res = await axiosInstance.post(API.LOGIN_CHECK_ACCOUNT, params);
      /*
      previous: false
      sign: null
      taskId: null
      twoFA: false
      username: "*@111.hk"
      */
      setCheckLoginToken(res);

      // res['previous'] = true
      // res['username'] = '1@11.xx'
      // auth rule data

      if (res['previous']) {
        setLoginUserInfo({
          usernameDisplay: res['username'],
          username: username,
          nationCode: nationCode,
        })
        // 检查是否首次登录 设置登录步骤
        setLoginStep(LOGIN_STEP.LOGIN_PW_SET);
      } else {
        // 设置登录步骤
        setLoginStep(LOGIN_STEP.LOGIN_PW_INPUT);
      }

    } catch(error) {
    } finally {
      setLoading(false);
    }
  }
  // 密码登录
  const _loginPw = async () => {
    if (asMobile && nationCode == null) {
      return;
    }
    
    try {
      setLoading(true);
      const params = {
        username,
        password,
        sign: checkLoginToken?.sign,
        device: getDeviceId(),
        deviceId: getDeviceId(),
      };
      if (asMobile) {
        params.nationCode = nationCode;
      }

      const res:any = await axiosInstance.post(API.LOGIN, params);
     

      // 2FA流程
      if (res['twoFA']) {
        const taskData = res['data']['authRule'];
        if (res['tokenValue']) {
          setTmpToken(res['tokenValue']);
        }
        /**
         * taskId
         * authCount    2
         * options   ['email', 'mobile']
         * optionsFix  ['email']
         * email
         * mobile
         * reason
         */
        // 2FA 流程
        setTaskRuleParams({
          taskId: taskData.taskId,
          action: VerifyAction.LOGIN,
          task: taskData,
          sign: res['sign'],
        });
        onToggleShow2FA();
        // navigate({
        //   pathname: RouteConstant.SECURITY_2FA,
        //   search: createSearchParams({
        //     taskId: taskData.taskId,
        //   }).toString()
        // });
        return;
      } 
      onLoginCallback(res);
      dispatch(getUserInfo());
      _onSubmitHandlerSuccess();
    } catch(error) {
    } finally {
      setLoading(false);
    }
  }
  // 首次登录设置密码
  const _loginPwSet = async () => {
    if (asMobile && nationCode == null) {
      return;
    }
    
    try {
      setLoading(true);
      const params = {
        username,
        password, 
        code,
        sign: checkLoginToken.sign,
        device: getDeviceId(),
      };
      if (asMobile) {
        params.nationCode = nationCode;
      }
      const res = await axiosInstance.post(API.LOGIN_REFERRAL, params);
      onLoginCallback(res);

      _onSubmitHandlerSuccess();
    } catch(error) {
    } finally {
      setLoading(false);
    }
  }

  // 2FA 通过登录
  const _on2FAAllPass = async () => {
    onToggleShow2FA();
    setLoading(true);
    try {
      const params = {
        taskId: getTaskId(),
        deviceId: getDeviceId(),
        deviceInfo: getDeviceId(),
      };

      const res = await axiosInstance.post(API.LOGIN, params);
      onLoginCallback(res);
      dispatch(getUserInfo());

      _onSubmitHandlerSuccess();
    } catch(error) {
    } finally {
      setLoading(false);
    }
  }

  const onNationCodeChange = function(val) {
    setNationRecord(val);
    setNationCode(val.areaCode);
  };

  const onUsernameChange = function(e) {
    const username = e.target.value?.trim() || '';
    setUsername(username);
    const isMobile = !isNaN(username);
    setAsMobile(isMobile);
  };

  const _signInGoogle = () => {
    setGoogleLogining(true);
    signInGoogle(autoSubmitOn3rdAuth);
  }

  const _onForgotPw = () => {
    dispatch(onForgotPwState({
      username: username,
      nationCode: nationCode,
    }));
    navigate(RouteConstant.FORGOT_PW);
  }

  const onLoginCallback = (res) => {
    if (isJSONStr(res.data )) {
      res.data = JSON.parse(res.data)
    }
    if (res?.se && res?.sa) {
      const algInfo = {
        se: res.se,
        sa: res.sa
      }
      localStorage.setItem('algInfo', JSON.stringify(algInfo))
    }
    setToken(res?.data?.data.tokenValue);
  }

  // 用户名检查
  if (loginStep === LOGIN_STEP.LOGIN_CHECK_EXIST) {
    return <form autoComplete="off" onSubmit={handleSubmit}>
      <Box className={classes["login-box"]}>
        <AppTextField
          // sx={{paddingLeft:0}}
          label={t("email_Phone")}
          placeholder={t("email_Phone")}
          onChange={onUsernameChange}
          required
          value={username}
          error={usernameError}
          fullWidth
          InputProps={{
            startAdornment: asMobile ? (
              <InputAdornment position="start">
                <Stack direction={'row'} alignItems={'center'}>
                  <NationSelect variant='borderless' showAreaCode isCompact={true} selected={nationRecord} onSelect={onNationCodeChange}/>
                  <Box style={{ borderLeft: `1px solid ${theme.palette.divider}`, height: '20px' }}></Box>
                </Stack>
                {/*<NationChooser*/}
                {/*  record={nationRecord}*/}
                {/*  onChange={onNationCodeChange}*/}
                {/*/>*/}
              </InputAdornment>
            ) : null,
          }}
        />

        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
        >
          {t('next')}
        </AppLoadingButton>
        <Stack direction={'row'} sx={{ fontSize: 14}} spacing={1} alignItems={'center'} justifyContent={'center'}>
          <div>{t('create_account')}</div>
          <Link style={{cursor:"pointer"}} color="error" onClick={() => interceptAction?.()}>{t('register')}</Link>
        </Stack>
      </Box>
      {/* <Box className={'fixed-button'}>
          <Stack direction={'column'} gap={'24px'}>
            <Divider sx={{fontSize:'12px',fontWeight:400}}>{t('or_continue_with')}</Divider>
            <LoadingButton loading={googleLogining}
                           loadingPosition="end"
                           loadingIndicator={<CircularProgress size={16} />}
                           fullWidth
                           sx={{
                             border: `1px solid ${'rgba(16, 5, 28, 0.10)'}`,
                             padding: '12px 0',
                             [`& .MuiLoadingButton-loadingIndicator`]: {
                               right: '70px !important'
                             },
                             [`& .${circularProgressClasses.root}`]: {
                               color: theme.palette.brand.main,
                             }
                           }}
                           direction="row" justifyContent="center" alignItems="center" className={classes["login-other-channel"]} onClick={_signInGoogle}>
              <Stack gap='12px' direction="row" justifyContent="center" alignItems="center">
                <img src="/images/google.png" />
                <div className="h4">{t('continue_with_google')}</div>
              </Stack>
            </LoadingButton>
            
          </Stack>
        </Box> */}
    </form>
  }

  // 密码输入
  if (loginStep === LOGIN_STEP.LOGIN_PW_INPUT) {
    return <>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <Box className={classes["login-box"]}>
          <Box>
            <div>{checkLoginToken?.username}</div>
            <AppTextField
              placeholder={'password'}
              required
              value={password}
              error={!!passwordError}
              onChange={(e) => {
                setPassword(e.target.value?.trim());
              }}
              fullWidth
              type={visiblePassword === 'password1' ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleTogglePasswordVisibility('password1')}
                      edge="end"
                    >
                      {visiblePassword === 'password1' ? (
                        <RpIcon icon="eye_open" size={22} />
                      ) : (
                        <RpIcon icon="eye_close" size={22} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Link onClick={_onForgotPw} color={'text.secondary'} fontSize={'13px'} fontWeight={400} className={classes["link"]}>{t('forgot_pw')}</Link>
          </Box>
          <AppLoadingButton
            fullWidth
            loading={loading}
            variant="contained"
            color="primary"
            size="large"
            type="submit"
          >
            {t('login')}
          </AppLoadingButton>
        </Box>
      </form>

      <AppModal open={show2FA} onClose={_onClose2FAModal}>
        <Security2FA callback={_on2FAAllPass} onClose={_onClose2FAModal}/>
      </AppModal> 
    </>
  }

  // 没设置密码用户首次登录时
  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <Box className={classes["login-box"]}>
        {/*<AppTextField*/}
        {/*  label={t('password_set_first_login')}*/}
        {/*  placeholder={t('password')}*/}
        {/*  onChange={(e) => setPassword(e.target.value.trim())}*/}
        {/*  required*/}
        {/*  value={password}*/}
        {/*  error={passwordError}*/}
        {/*  fullWidth*/}
        {/*  type={visiblePassword === 'password2' ? 'text' : 'password'}*/}
        {/*  InputProps={{*/}
        {/*    endAdornment: (*/}
        {/*      <InputAdornment position="end">*/}
        {/*        <IconButton*/}
        {/*          aria-label="toggle password visibility"*/}
        {/*          onClick={() => handleTogglePasswordVisibility('password2')}*/}
        {/*          edge="end"*/}
        {/*        >*/}
        {/*          {visiblePassword === 'password2' ? (*/}
        {/*            <RpIcon icon="visible" size={22} />*/}
        {/*          ) : (*/}
        {/*            <RpIcon icon="invisible" size={22} />*/}
        {/*          )}*/}
        {/*        </IconButton>*/}
        {/*      </InputAdornment>*/}
        {/*    ),*/}
        {/*  }}*/}
        {/*/>*/}
        <PasswordInput
          label={t('password_set_first_login')}
          placeholder={t('password')}
          onChange={(e) => setPassword(e.target.value.trim())}
          required
          // value={password}
          error={passwordError}
          fullWidth
        />
        <AppTextField
          label={t('verify_code')}
          placeholder={t('verify_code')}
          onChange={(e) => setCode(e.target.value)}
          required
          value={code}
          error={codeError}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SendCodeButton
                  useRecaptcha={true}
                  ref={sendCodeBtnRef}
                  btnText={t('send_code')}
                  enable={true}
                  action="register"
                  params={{ email: loginUserInfo?.username }}
                  asMobile={asMobile}
                  onError={(error)=>{
                  }}
                />
              </InputAdornment>
            ),
          }}
        />

        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
        >
          {t('login')}
        </AppLoadingButton>
      </Box>
    </form>
  );
}
